import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7 9v6h4l5 5V4l-5 5H7z"
}), 'VolumeMuteSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/VolumeMuteSharp.js
// module id = 7168
// module chunks = 2